import React from 'react';

const NotFound = () => <div>Not yet built.</div>;

export default NotFound;
